const headtrack = [
  { id: 1, type: "headTrackColor", label: "Bronze Anodized" },
  { id: 2, type: "headTrackColor", label: "Clear Anodized" },
];

const headtrackAlumBifold = [
  { id: 1, type: "headTrackColor", label: "Jet Black" },
  { id: 2, type: "headTrackColor", label: "Clear Anodized" },
];

export { headtrack, headtrackAlumBifold };
